import { useLocation } from "react-router-dom";
import { Col, Collapse, Row } from "antd";
import styles from "./JobDetails.module.css";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { useState } from "react";
import engineer2 from "../../../assets/man1.png";
import { IMG_URL } from "../../../store/Apis";
import dummyImg from "../../../assets/dummy.png";
import moment from "moment";
import { t } from "i18next";

const { Panel } = Collapse;

const JobDetails = () => {
  const phoneFormat = (text) => {

    var cleaned = ("" + text).replace(/\D/g, "");
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      var intlCode = match[1] ? "+1 " : "",
        number = [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join(
          ""
        );
      return number;
    }
    return text;
  }
  const { state } = useLocation();
  const [isActiveOne, setIsActiveOne] = useState(true);
  const [isActiveTwo, setIsActiveTwo] = useState(false);
  const [isActiveThree, setIsActiveThree] = useState(false);
  console.log("stateeeeee", state);
  const serviceDetails = [
    {
      id: 1,
      name: "Mop Floor",
    },
    {
      id: 2,
      name: "Vacuum",
    },
    {
      id: 3,
      name: "Carpet Cleaning",
    },
  ];
  const inventories = [
    {
      id: 1,
      name: "Paper Towel",
      used: "1",
      total: "1",
    },
    {
      id: 2,
      name: "Mop",
      used: "0",
      total: "2",
    },
    {
      id: 3,
      name: "Wiper",
      used: "1",
      total: "1",
    },
    {
      id: 4,
      name: "Bucket",
      used: "0",
      total: "4",
    },
    {
      id: 5,
      name: "Brush",
      used: "1",
      total: "1",
    },
  ];
  const customizeIcon = () => {
    if (isActiveOne == true) {
      return (
        <MdKeyboardArrowUp
          style={{
            color: "var(--secondary-color)",
            width: "50px",
            height: "50px",
          }}
        />
      );
    } else {
      return (
        <MdKeyboardArrowDown
          style={{
            color: "var(--secondary-color)",
            width: "50px",
            height: "50px",
          }}
        />
      );
    }
  };
  const customizeIconTwo = () => {
    if (isActiveTwo == true) {
      return (
        <MdKeyboardArrowUp
          style={{
            color: "var(--secondary-color)",
            width: "50px",
            height: "50px",
          }}
        />
      );
    } else {
      return (
        <MdKeyboardArrowDown
          style={{
            color: "var(--secondary-color)",
            width: "50px",
            height: "50px",
          }}
        />
      );
    }
  };
  const customizeIconThree = () => {
    if (isActiveThree == true) {
      return (
        <MdKeyboardArrowUp
          style={{
            color: "var(--secondary-color)",
            width: "50px",
            height: "50px",
          }}
        />
      );
    } else {
      return (
        <MdKeyboardArrowDown
          style={{
            color: "var(--secondary-color)",
            width: "50px",
            height: "50px",
          }}
        />
      );
    }
  };
  return (
    <div className={styles.mainCon}>
      <Collapse
        className={styles.Collapse}
        expandIconPosition="end"
        onChange={() => setIsActiveOne(!isActiveOne)}
        expandIcon={() => customizeIcon()}
        defaultActiveKey={'1'}
        ghost
      >
        <Panel
          className={styles.panel}
          header={<p className={styles.header}>{t("Basic Information")}</p>}
          key="1"
        >
          <div className={styles.panelOneHeader}>
            <img
              src={
                state?.customer_image
                  ? IMG_URL + state?.customer_image
                  : dummyImg
              }
            />
            <h1>{state?.customer_name}</h1>
          </div>
          {/* <h1 className={styles.subHeading}>{t("Basic Information")}</h1> */}
          <Row className={styles.panelOneRow}>
            <Col className={styles.panelOneCol}>
              <div className={styles.panelOneDiv}>
                <span>{t("Cleaner Name")}</span>
                <p>{state?.cleaner_name}</p>
              </div>
              <div className={styles.panelOneDiv}>
                <span>{t("Category")}</span>
                <p>{state?.service_type}</p>
              </div>
              <div className={styles.panelOneDiv}>
                <span>{t("Service Name")}</span>
                <p>{state?.service_name}</p>
              </div>
            </Col>
            <Col className={styles.panelOneCol}>
              <div className={styles.panelOneDiv}>
                <span>{t("Location")}</span>
                <p>{state?.location?.address}</p>
              </div>
              <div className={styles.panelOneDiv}>
                <span>{t("Urgency")}</span>
                <p>{state?.urgency}</p>
              </div>
            </Col>
            <Col className={styles.panelOneCol}>
              <div className={styles.panelOneDiv}>
                <span>{t("Contact Number")}</span>
                <p>{phoneFormat(state?.customer_contact)}</p>
              </div>
              <div className={styles.panelOneDiv}>
                <span>{t("Date")}</span>
                <p>{moment(state?.date).format("MM-DD-YYYY")}</p>
              </div>
            </Col>
            <Col className={styles.panelOneCol}>
              <div className={styles.panelOneDiv}>
                <span>{t("Timing")}</span>
                <p>
                  {moment("01 jan 1940 " + state?.start_time).format(
                    "hh:mm A"
                  ) +
                    " To " +
                    moment("01 jan 1940 " + state?.end_time).format("hh:mm A")}
                </p>
              </div>
              <div className={styles.panelOneDiv}>
                <span>{t("Email")}</span>
                <p>{state.customer_email}
                </p>
              </div>
            </Col>
          </Row>
        </Panel>
      </Collapse>
      <div className={styles.bottomDiv}>
        <div className={styles.bottomDivLeft}>
          <Collapse
            className={styles.Collapse}
            expandIconPosition="end"
            onChange={() => setIsActiveTwo(!isActiveTwo)}
            expandIcon={() => customizeIconTwo()}
            ghost
          >
            <Panel
              className={styles.panel}
              header={<p className={styles.header}>{t("Inventories")}</p>}
              key="1"
            >
              {/* <h1 className={styles.panelTwoHeading}>{t("Inventories")}</h1> */}
              <div className={styles.panelTwolist}>
                {state?.inventories?.length ? (
                  state?.inventories.map((item, index) => {
                    return (
                      <div className={styles.panelTwoRow}>
                        <div className={styles.panelTwoMainCol}>
                          <h1>{item?.name}</h1>
                        </div>
                        <div className={styles.panelTwoMainCol}>
                          <div className={styles.panelTwoSubMainCol}>
                            <span>{item?.quantity_used}</span>
                            <p>Used</p>
                          </div>
                          <div className={styles.panelTwoSubMainCol}>
                            <span>{item?.quantity}</span>
                            <p>Total</p>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className={styles.panelTwoMainCol}>
                    <h1>No items</h1>
                  </div>
                )}
              </div>
            </Panel>
          </Collapse>
        </div>
        <div className={styles.bottomDivRight}>
          <Collapse
            className={styles.Collapse}
            expandIconPosition="end"
            onChange={() => setIsActiveThree(!isActiveThree)}
            expandIcon={() => customizeIconThree()}
            ghost
          >
            <Panel
              className={styles.panel}
              header={
                <p className={styles.header}>{t("Service Details")}</p>
              }
              key="1"
            >
              {/* <h1 className={styles.panelTwoHeading}>{t("Service Details")}</h1> */}
              <div className={styles.panelTwolist}>
                {/* {serviceDetails.map((item, index) => {
                  return ( */}
                <div className={styles.panelTwoRow}>
                  <div className={styles.panelThirdMainCol}>
                    <h1>{state?.details}</h1>
                  </div>
                </div>
                {/* );
                })} */}
              </div>
            </Panel>
          </Collapse>
        </div>
      </div>
    </div>
  );
};
export default JobDetails;
